import { ChevronDown } from "lucide-react";
import { type FC, type ReactNode, useState } from "react";

import { cn } from "@/lib/utils";
import { m } from "@recobra/i18n/messages";

import { Button } from "../ui/button";

export const ExpandableText: FC<{
  text: string;
  children?: ReactNode;
  /** Expanded text scrolls inside a fixed height instead of growing, for places with limited room. */
  scrollable?: boolean;
}> = ({ text, children, scrollable = false }) => {
  const [open, setOpen] = useState(false);
  const canCollapse = text.length > 360 || text.split("\n").length > 4;
  const content = children ?? text;

  if (!canCollapse) {
    return <p className="whitespace-pre-wrap text-sm leading-6 text-foreground/90">{content}</p>;
  }

  return (
    <div>
      <div
        className={cn(
          !open && "relative max-h-[5.9rem] overflow-hidden",
          open && scrollable && "max-h-60 overflow-y-auto",
        )}
      >
        <p className="whitespace-pre-wrap text-sm leading-6 text-foreground/90">{content}</p>
        {!open && (
          <div className="absolute inset-x-0 bottom-0 h-9 bg-gradient-to-b from-transparent to-card" />
        )}
      </div>
      <Button type="button" variant="link" size="xs" onClick={() => setOpen((current) => !current)}>
        {open ? m.notes_show_less() : m.notes_read_more()}
        <ChevronDown data-icon="inline-end" className={open ? "rotate-180" : undefined} />
      </Button>
    </div>
  );
};
